export type ValidationType = 'error' | 'success';

type ValidationIconEntry = {
  inlineIcon: string;
  messageIcon: string;
  color: string;
};

export const VALIDATION_CONFIG: Record<ValidationType, ValidationIconEntry> = {
  error: { inlineIcon: 'caution-outline', messageIcon: 'caution-fill-sm', color: 'red' },
  success: { inlineIcon: 'check-circle-outline', messageIcon: 'check-circle-fill-sm', color: 'success' },
};
